var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-boolean",class:{
        'c-boolean--is-disabled': _vm.Disabled,
        'c-boolean--is-checked': _vm.value,
        'c-boolean--is-checkbox': _vm.Checkbox
    },on:{"click":_vm.toggle}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-boolean__wrapper"},[_c('span',{staticClass:"c-boolean__switch"})])}]

export { render, staticRenderFns }